module.exports = __webpack_public_path__ + "img/instacash-logo-white.6d68c8d6.svg";